import { useDesignMaxTheme } from "@/packages";
import { Box, Center, chakra, Image } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Pagination } from "../pagination";
import { useOpacitySlide } from "./hooks/useOpacitySlide";
import { type OpacitySlideProps } from "./types/opacitySlide.type";

export const OpacitySlide = ({
    isControls = true,
    imgList,
    autoPlay = true,
    time = 5900,
    opacityTime = 0.7,
    children,
    ease = "easeIn",
}: OpacitySlideProps) => {
    const { currentIdx, nextSlide, prevSlide, ref, handleTouchStart, handleTouchEnd } = useOpacitySlide({
        imgList,
        time,
        autoPlay,
    });
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    return (
        <Center
            ref={ref}
            position="relative"
            w="100%"
            h="100%"
            overflow="hidden"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            {imgList.map((img, index) => (
                <MotionOpacityContainer
                    key={`${img.img_URL}`}
                    position="absolute"
                    w="100%"
                    h="100%"
                    initial={{ opacity: index === currentIdx ? 1 : 0 }}
                    animate={{
                        opacity: index === currentIdx ? 1 : 0,
                        transition: { duration: opacityTime, ease },
                    }}
                >
                    <MotionOpacityImg
                        position="absolute"
                        w="100%"
                        h="100%"
                        // background={`url(${img.img_URL}) no-repeat center/cover`}
                    >
                        {img.img_URL ? (
                            // <Box w="100%" h="100%" bg={`url(${img.img_URL})no-repeat center/cover`} />
                            <Image w="100%" h="100%" src={img.img_URL} />
                        ) : (
                            <Box w="100%" h="100%" bg="gray.100" />
                        )}
                    </MotionOpacityImg>
                </MotionOpacityContainer>
            ))}
            <Center
                position="absolute"
                bottom={isMobile ? "15%" : "10%"}
                w="100%"
                maxW="1920px"
                paddingX="24px"
                flexDir="column"
                zIndex="1"
                rowGap={isMobile ? "12px" : "48px"}
            >
                {children && children}
                {isControls && (
                    <Box>
                        <Pagination
                            currentPage={currentIdx}
                            totalPages={imgList.length}
                            nextPage={nextSlide}
                            prevPage={prevSlide}
                        />
                    </Box>
                )}
            </Center>
        </Center>
    );
};

const MotionOpacityContainer = chakra(motion.div);
const MotionOpacityImg = chakra(motion.div);
